import { createAction } from 'redux-actions';
export const SET_MODAL = 'REFUND/SET_MODAL';
export const CLOSE_MODAL = 'REFUND/CLOSE_MODAL';
export const setModal = createAction(SET_MODAL);
export const closeModal = createAction(CLOSE_MODAL);
